var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg124(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 182,
    viewBox: "0 0 207 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_2552_5162)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2552_5162)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 30,
    width: 106.704,
    height: 34.56,
    rx: 12,
    fill: "#EF0505"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 86.7197,
    y: 44.786,
    width: 56.16,
    height: 3.85714,
    rx: 1.92857,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2552_5162)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.3438,
    y: 36.6031,
    width: 20.304,
    height: 20.304,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 61.5713,
    y: 40.9286,
    width: 12,
    height: 12,
    fill: "url(#pattern0_2552_5162)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2552_5162)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.704,
    height: 34.56,
    rx: 12,
    transform: "matrix(-1 0 0 1 156.704 76.56)",
    fill: "#EF0505"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 56.16,
    height: 3.85714,
    rx: 1.92857,
    transform: "matrix(-1 0 0 1 119.984 91.346)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2552_5162)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.304,
    height: 20.304,
    rx: 8,
    transform: "matrix(-1 0 0 1 149.36 83.1631)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 133.133,
    y: 87.4886,
    width: 12,
    height: 12,
    fill: "url(#pattern1_2552_5162)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_2552_5162",
    x: 31,
    y: 27,
    width: 144.704,
    height: 150.12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2552_5162"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2552_5162",
    result: "effect2_dropShadow_2552_5162"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 26
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2552_5162",
    result: "effect3_dropShadow_2552_5162"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 47
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2552_5162",
    result: "effect4_dropShadow_2552_5162"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_2552_5162",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2552_5162",
    x: 0,
    y: 0,
    width: 206.704,
    height: 134.56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.235294 0 0 0 0 0.313726 0 0 0 0 0.878431 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2552_5162"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2552_5162",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2552_5162",
    x: 33.3438,
    y: 16.6031,
    width: 80.3037,
    height: 80.304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.139757 0 0 0 0 0.211636 0 0 0 0 0.729167 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2552_5162"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2552_5162",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2552_5162",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2552_5162",
    transform: "scale(0.00195312)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2552_5162",
    x: 0,
    y: 46.56,
    width: 206.704,
    height: 134.56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.235294 0 0 0 0 0.313726 0 0 0 0 0.878431 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2552_5162"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2552_5162",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2552_5162",
    x: 105.057,
    y: 63.1631,
    width: 80.3037,
    height: 80.304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.139757 0 0 0 0 0.211636 0 0 0 0 0.729167 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2552_5162"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2552_5162",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_2552_5162",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2552_5162",
    transform: "scale(0.00195312)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2552_5162",
    width: 512,
    height: 512,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAACXBIWXMAAEuXAABLlwHuxW8gAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAIABJREFUeJzt3Xe0X2WdtvHrpEGAUIPSQm/SmxQpAaUaFFGpgmIBC0sHrK9OkaK+ijqWcRQUBQWpgtJBiiAQpChNkF4EpPdO2vzxBALh5NS99/fZ+7k+a+0FzlpD7pycnH3/ngqSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJEmSJKlKPdEBVKz5gEWAkcAoYFxsHEnD8BQwA3gFeBx4MTaOBsICoDr0AMsCawIrzPz35YClgfEzn7mCskmq3/OkIvAwcC9wz8znNuBG4KGoYJrFAqAqLAlsOvNZn/Tinz80kaScPQLcAFwJTAauAJ4MTVQgC4CGYhywNbA9sC3pE74kDdV04CbgPOAc4DLSdIJqZAHQQC0CvB/YFZgIjI6NI6nDniMVgZOAs3BNQS0sAOrLGGBnYB/SJ/5RoWkkleg54HTgV8BFpMWGqoAFQL1ZEfgk8BFg0eAskvSqO4BfznweDc7SehYAvd76wL8Be5K250lSjl4mTQ/8f+AfwVlaywIggG2Ag4B3BOeQpMGYDvye9PPr77FR2scCULYtgENn/lOS2mo6cCJwMHBrcJbWsACUaQXS0Nku0UEkqUJTSYsF/wPXCPTLed6yzAccAhwDrBWcRZKqNoK0luljwLPA33DXwBw5AlCOicAvgJWig0hSQ/4GfAK4NjpIjhwB6L6FgCOAH5AO85GkUiwOfJR0hsnlpLUCmskRgG7bCvgNsFR0EEkKdg2wFy4SfM2I6ACqxWjgMOACfPlLEsAGwF+BfaOD5MIRgO5ZlLQdZqvoIJKUqd8C+wEvRAeJZAHolk2Bk0nzXpKkObsO+ABwV3SQKE4BdMc+pIsyfPlLUv/WAa4kfXAqkgWg/XpIx2D+inR7nyRpYMYDF5LuPymO2wDbbRRwFOkCH6dzJGnwRgHvJ107fEVwlkZZANprDHA8sEd0EElquR5gW2AsafdUESwA7TQWOBXYKTqIJHXIZsA44PzoIE2wALTPGOAUYFJ0EEnqoHcACwLnRgepmwWgXUaS9q/uHB1Ekjps45n/vCQ0Rc0sAO3RA/wa5/wlqQlbAs8AfwnOURsLQHt8E9g/OoQkFWRb4HbgxuggdXDrWDt8DPhldAhJKtBLwLuAydFBqmYByN+WwB9JF/xIkpr3COkyofuig1TJApC3xUm3V3m8ryTFupZ0bPCL0UGq4hqAfI0GzgJWiw4iSWJxYALwh+ggVbEA5OsHwC7RISRJr1mbdHvgDdFBquAUQJ62JR1C4Z+PJOXlOWA90u6AVvMFk5/xpHbpvL8k5elq0nqAKdFBhsMpgPwcDWwUHUKSNEdLAi8Al0UHGQ5HAPKyI3BGdAhJUr9eBtYBbokOMlQWgHzMD9wELBUdRJI0IJcAWwEzooMMhVMA+fgesHV0CEnSgC1L2hVwfXCOIXEEIA9vI30DedqfJLXLw8DKpIuDWsURgDwcS/oGkiS1y3ykKYCLooMMliMA8XYAzo4OIUkaspeAVYB/RgcZDEcAYvWQPv0vGR1EkjRko4B5gTOjgwyGIwCxdgZOjQ4hSRq2KaT1XHdGBxkoRwDi9AAnAG+NDiJJGraRpO3cp0UHGShHAOI49y9J3TIFWAG4LzrIQDgCEOdwYPnoEJKkyowklYALooMMhCMAMdYGrosOIUmq3FPA0sCz0UH6MyI6QKH2jw4gSarFgsCHokMMhCMAzZsPeIC0WESS1D1/BTaIDtEfRwCatye+/CWpy9YH1osO0R8LQPM+Gh1AklS77H/WOwXQrKWBe/DrLkld9yiwBDA1OsicOALQrN3x5S9JJVgU2CI6RF8sAM3aJTqAJKkxu0YH6IufRpuzOGn1v19zSSrDg6TL3mZEB+mNIwDN2QFf/pJUksWBNaNDzIkFoDk7RAeQJDUu25/9FoBmjAC2jg4hSWrcdtEB5sQC0Iw1SMdDSpLKsjEwJjpEbywAzdg0OoAkKcRYYJ3oEL2xADTDAiBJ5dosOkBvLADNyP5SCElSbd4eHaA3FoD6jQVWjA4hSQqT5VZAC0D91gRGRoeQJIVZBZg7OsTsLAD1WyM6gCQp1Chg1egQs7MA1M/hf0lSdu8CC0D9lo0OIEkKt1x0gNlZAOqX3R+6JKlxy0YHmJ0FoH5LRweQJIVbJjrA7CwA9eoBFo0OIUkKl927wAJQrwWA0dEhJEnhxkcHmJ0FoF6LRAeQJGXBAlAYbwCUJAGMI7ND4SwA9cru5CdJUogeMrsW2AJQr6z+sCVJoeaKDvB6FoB6WQAkSa/K6p1gAajXqOgAkqRsWAAkSVIsC4AkSQWyAEiSVCALgCRJBbIASJJUIAuAJEkFsgBIklQgC4AkSQWyAEiSVCALgCRJBerSUbULA6sBK5CuXZw3Ng4Aq0YHkCSpN20vAKsBewGTgDVJ1y1KkqR+tLUAbAb8J7BtdBBJktqobQVgPPBDYE/8tC9J0pC1qQBsBpwALBkdRJKktmvLLoD3Aefjy1+SpEq0YQRgEnASMDo6iCRJXZF7AVgTX/5Sf54A7gf+CdwH/At4HHjydc9cwCLAoqTtqZsD65L/zwBJNcn5L/9Y4ERgnuggUibuAq4FbgVumfnPW4Gnh/jfGwfsCOwPbFpFQEntkfNK+kNIW/2kEj0CXApcTnrpX8vQX/QDsQ7wDdKUm6R6TCCN1mUh1wKwBHAnMHd0EKkhDwCXkF76fwZuDsrxAdJW26WCfn2py7IqALlOARyIL3912yvAhcCpwJ9IhTcHpwAXzfznVsFZJNUoxxGA0aRFTOOjg0gVewm4ADgD+D3waGycPo0C/gf4VHQQqUMcAejHtvjyV7fcBHyH9NJ/LjjLQE0FPg2MAT4WnEVSDXIsAFtHB5AqchNwGPBbYFpwlqH6FLA0/r2UOifHkwA3jg4gDdOzwGeBtYDf0N6XP8AUYFfS+QKSOiTHArBydABpGM4B1gB+AkwPzlKVJ4EDokNIqlZuBWAeYOHoENIQTCF96n836US+rjkVODs6hKTq5FYA5osOIA3BI6Q58p9EB6nZ16IDSKpObgVgTHQAaZBuAjYgHd7TddcDk6NDSKpGbgVAapPrSYfllLRA7mfRASRVwwIgDc21pGH/nA/zqcMpwAvRISQNnwVAGrxbgHcBj0UHCfAi6ehiSS1nAZAG53HgvaStcaU6KzqApOGzAEgD9wrwQeD26CDBzgRmRIeQNDwWAGng9gcujg6RgfuAG6JDSBoeC4A0ML8HjowOkZEzogNIGh4LgNS/B4B9o0NkxnUAUstZAKS+zQD2IS3+0yxXkU5AlNRSFgCpb8cDF0SHyNB0vBtAajULgDRnzwJfjg6RMacBpBazAEhzdhBp/l+9Oxd4OTqEpKGxAEi9ux34n+gQmXsOuDQ6hKShsQBIvTsUmBIdogWcBpBaygIgvdntpMV/6t/p0QEkDY0FQHqzg4Gp0SFa4i7S5UiSWsYCIL3RXcAJ0SFa5szoAJIGzwIgvdH/AtOiQ7SMBUBqIQuANMsLwNHRIVroMjwpUWqd3ArA9OgAKtqxwBPRIVpoGnB+dAhJg5NbAXghOoCK9tPoAC3mNIDUMrkVgGdx9bVi3ABcHx2ixc7BtRNSq+RWAKYBd0eHUJGOiw7Qck8Ak6NDSBq43AoApE9iUpOm48E/VXAaQGqRHAvAJdEBVJzLgH9Gh+gAjwWWWiTHAnA67gZQs06JDtARNwF3RoeQNDA5FoB7gT9Hh1BRzo4O0CF+LaWWyLEAAPwgOoCKcQtwR3SIDnEdgNQSuRaAM4Cro0OoCH5irdYlpO28kjKXawGYAeyP+4pVPxeuVetl4ILoEJL6l2sBgDQC8M3oEOq0l4ErokN0kNMAUgvkXAAADsFPaKrPNcCL0SE66GzcySNlL/cCMA3YFbg0Oog6ye+rejxEKleSMpZ7AYB0QdB2wGnRQdQ5l0UH6DCnAaTMtaEAQBqm3Rn4KjAlOIu6YTpweXSIDnPqTspcWwoApJ0B3wbWwVXGGr47gaeiQ3TYtcAD0SEkzVmbCsCrbga2ATYFTgJeio2jlro2OkDHzcBRAClro6IDDMPkmc8CwDuBLYHVgeWBBWf+39tYcNSM66IDFOBMYL/oEJJ61xMdoOMm4WKoXG0PnBcdouPGAo8B80QHkTIxAbg/OsSr/ISsUjkCUL8XgT9Fh5DUOwuASvQ48HB0iEK4DkDKlAVAJfL2v+acSVoQKCkzFgCV6PboAAW5D7ghOoSkN7MAqESOADTLhbBShiwAKpEFoFmuA5AyZAFQie6MDlCYK4FHo0NIeiMLgEqUzT7cQkwnXREsKSMWAJVmOum6WjXLaQApMxYAleYRYGp0iAKdB7wSHULSLBYAlebB6ACFeoZ0d4ekTFgAVBqvqI3jscBSRiwAKo2r0eNcFR1A0iwWAJXmqegABbstOoCkWSwAKs2T0QEK5gVMUkYsACrN09EBCvYCaRumpAxYAFQapwDijMSfOVI2/Muo0jgCEGeB6ACSZrEAqDTPRQco2PLRASTNYgFQaV6ODlCwNaIDSJrFAqDSvBQdoGCbRweQNIsFQKXxPPoYI4Bto0NImsUCoNI4BRBjS2DJ6BCSZrEAqDQWgBj7RweQ9EYWAJVmWnSAAq0K7BQdQtIbWQBUmp7oAAX6PukQIEkZsQCoNL6ImrUn8O7oEJLezAKg0vg935wVgJ9Gh5DUO38YqjR+zzdjYeAsPP5XypY/DFUav+frtxBwDrBKdBBJc+YPQ5VmVHSAjlsVmAxsGB1EUt8sACrNPNEBOqoH+DhwFakESMqcBUClmTc6QAdtBlwMHAmMi40iaaAcDlVpHAGoxjjgA6RP/ZsFZ5E0BBYAlcYCMHRzA9sAuwA7A/PFxpE0HBYAlcYpgMEZCWwFfJh0nO/8sXEkVcUCoNJYAPr36kt/N+D9pD39kjrGAqDSLBgdIGPrkz7p7wIsHpxFUs0sACqNn2bfaF3Sef27AROCs0hqkAVApVkkOkAGlgI+BuyBe/alYlkAVJqSC8BE4EBgR7wVUSqeBUClKXEKYHngCGDr6CCS8mEBUGlKGwHYETgOT+iTNBsLgEozPjpAg3YGTsbhfkm98C4AlWYRYEx0iAasTfrk78tfUq8sACpND93f4z4a+C3p6F5J6pUFQCVaMjpAzT4JrB4dQlLeLAAq0RLRAWr2megAkvJnAVCJulwAJgJviw4hKX8WAJWoywVgn+gAktrBAqASdfnM+4nRASS1gwVAJVo+OkBN3gIsFx1CUjtYAFSirhaAd0QHkNQeFgCV6C1082jclaIDSGoPC4BK1cWh8kWjA0hqDwuAStXFaQALgKQBswCoVF0sACVddCRpmCwAKlUX58u93VPSgFkAVKrVogPUYEp0AEntYQFQqbpYAKZGB5DUHhYAlWo83Vs05wiApAGzAKhkXbs056noAJLawwKgknVtGuDB6ACS2sMCoJJ1bQTAAiBpwCwAKtla0QEq9q/oAJLawwKgkq0D9ESHqND90QEktYcFQCVbEFg2OkSFbgWmR4eQ1A4WAJVu3egAFXoB+Gd0CEntYAFQ6bpUAABujg4gqR26cnb4eGBzYHVgZWAeYIHQRImXs+RvnegAFbsZeHd0CEn5a3MBGAfsPfPZiG4t5lJzujYCcGN0AEnt0MYCMBb4InAAsHBwFrXfksDidGcP/ZXRASS1Q9vWAGwO/B04BF/+qs7G0QEqdBvwRHQISflrUwH4InARsHx0EHXORtEBKjQDuCo6hKT8taUAfA/4Lu2cslD+ujQCAPCX6ACS8teGAnAQ8IXoEOq0DehWubwiOoCk/OVeAD4AfD06hDpvXmCN6BAVugx4OTqEpLzlXACWAI6MDqFidGka4AWcBpDUj5wLwPdJZ7VLTdgkOkDFLogOIClvuRaAtYHdokOoKFtFB6jYhdEBJOUt1wLwZTzZT82aQLduBrwaeDo6hKR85VgA5gd2jg6hIm0RHaBCU4Hzo0NIyleOBeC9pON+paZtGR2gYmdEB5CUrxwLQNfmYtUeXRoBADiTNBIgSW+SYwHYIDqAirUCsHR0iAo9gYcCSZqD3ApAD7BidAgVrWujAE4DSOpVbgVgPmCe6BAq2jbRASp2enQASXnKrQDMGx1AxduGbm1BvRW4ITqEpPzkVgC6dCGL2mlxYM3oEBU7OTqApPzkVgCkHGwbHaBix0cHkJQfC4D0Zl0rAHcC10WHkJQXC4D0ZpvTvcWoJ0UHkJQXC4D0ZnOTSkCXnAjMiA4hKR8WAKl3k6IDVOwuYHJ0CEn5sABIvXtvdIAaHBMdQFI+LABS75ahe9sBTwBejA4hKQ8WAGnOujYK8DRwVnQISXmwAEhz9p7oADVwGkASYAGQ+vJ2YLHoEBU7B3g4OoSkeBYAac5GADtGh6jYFOCo6BCS4lkApL7tFB2gBr8ApkeHkBTLAiD1bRtggegQFbsLuCA6hKRYFgCpb3PRzcWAR0QHkBTLAiD1b5foADU4HXggOoSkOBYAqX/bAfNHh6jYVFwMKBXNAiD1by66txsA4OfAtOgQkmJYAKSB+WB0gBrcB5wXHUJSDAuANDDbA+OiQ9Tg8OgAkmLkVgCmRgeQ5mAssHN0iBqcTRoJkFSY3ArA89EBpD58KDpADaYBv4oOIal5PdEBZtMDPAfMEx1E6sU0YALwYHSQii0F3A2Mig4iddwE4P7oEK/KbQRgBnB7dAhpDkYCu0eHqMH9wKnRISQ1K7cCAHBNdACpD12cBgD4bnQASc3KsQD8KTqA1If1gdWiQ9TgGuCy6BCSmpNjATgDeDE6hNSHPaMD1OT70QEkNSfHAvAMzkcqb3uT59+d4ToduCM6hKRm5PpD7DDSgkApR0sDW0eHqMF04IfRISQ1I9cCcANwfHQIqQ+fiA5Qk6OBJ6JDSKpfrgUA4IvAk9EhpDnYCRgfHaIGz+PxwFIRci4ADwIfxqkA5WkMsFd0iJr8GHgpOoSkeuVcAADOBL4eHUKag49HB6jJw8AJ0SEk1Sv3AgBwKGlRoJSbNYCNo0PU5L9x9E3qtDYUAICvAAfgbYHKT1dHAW4Ezo8OIak+bSkAAD8CJuI+ZeVlD2DB6BA1ceRN6rA2FQCAyaRh168BjwdnkQDmBT4SHaImFwKXR4eQVI/crgMejPlIF7PsDWxC+8qMuuM2YFW6OWe+HXBudAipI7K6DrjNBeD1FgY2B1YHVgTGkcew7HhgnegQasR2wB+jQ9TkSmDD6BBSB1gACjKJtJVR3Xc66XCgLtqRdEmXpOHJqgA4bC5VYxKwTHSImpwF/C06hKRqWQCkaowEPhUdoiYzgP+KDiGpWhYAqTqfAMZGh6jJWcBl0SEkVccCIFVnPGlXSld9NTqApOpYAKRqfYHu/r26DDgnOoSkanT1B5UUZWVgh+gQNfp/wPToEJKGzwIgVe8L0QFqdANwYnQIScNnAZCqtxWwbnSIGn0ZeCE6hKThsQBI9fh8dIAa3Q/8MDqEpOGxAEj12A1YKjpEjb4NPBQdQtLQWQCkeowGDowOUaNngf+IDiFp6CwAUn0+SToboKuOwiOCpdayAEj1mRf4XHSIGk0nlZxp0UEkDZ4FQKrX58jjauq6XAMcER1C0uBZAKR6LUB3Lwl61VeBf0WHkDQ4FgCpfgcC80SHqNEzpLMBJLWIBUCq31uAj0eHqNlv8Z4AqVUsAFIzvgzMHR2iZvsCT0aHkDQwFgCpGUuRXpBd9gDd3vUgdYoFQGrO1+j2WgCAY4HfRYeQ1D8LgNScxej+jgCAz+AxwVL2LABSs74KjIsOUbNHgT3wgCApaxYAqVnjSZ+Qu+5i4OvRISTNmQVAat6XgPmjQzTgW8Bp0SEk9W5UdACpQIuQDgc6ODpIzWaQzj9YE1g+OMtg3QxcCFwF3Eqa1ngaGEM62nlZYDVgC2Ar0omPkvSaSaQfgj4+sz/PAG+lDKsAjxP/Ne/veRb4b2CNQf7+5gLeB5yfwe/BJ+9nKVQMC4BPX89PKMcWwEvEf817e14ADqOaq5vfDlyawe/JJ8/HAlAQC4BPX88rwIqUY0/SFcLRX/dXn6nAr4AJFf8+e0jXJD+Xwe/RJ68nqwLgIkApzmjgm9EhGnQcsB+pBEQ7E1gb+BhwX8X/7RmkK5I3BO6u+L8tVcYCIMXahTRsXIojSS/dqDMC/gJMBN4D3FTzr3UzsDHw95p/HWlILABSrB7S/HNJfg3sDUxp8Ne8DngvsAnw5wZ/3UeArYE7Gvw1pQGxAEjxtiR9Ii3J8aQX48M1/zo3A7sC6wFn1PxrzcnDwE6kXQZSNiwAUh6+T9pjXpI/AxuQ9tpX7TbSKMOawMmkeflINwP/FpxBegMLgJSHlYDPRocIcD9pi+ChpG2Cw3UzsBfpkJ5jyWPB4auOJp0VIKkAbgP0GczzDOnGwFKtAJzF0L52NwIfBkY2nnpwViVt/4z+XvOJedwGKKlX4+j+8cB9uZNUmjcEfkHaR9+fycDOwFrAb8j/BsJbgMOjQ0iQViCrPpNI+42lgZoGrA9cHx0kA+NI5+xvTLpLYBHSNMH9wLXABcBdYemGbmHg9pn/VFkmkL5/VQCnAHyG8lyEuu6zxH+f+TT/OAUgqU9bAbtHh1CtfoYHBCmYBUDK0w/witkum0q6EloKYwGQ8rQYcFB0CNXqAuCc6BAqlwVAytdngXWiQ6hWn6fZI5Gl11gApHyNJN0q59/T7rqFtB5Aapw/WKS8bQh8NDqEanUQ8Fh0CJXHAiDl79vAotEhVJsnKfsAKAWxAEj5Gw/8MDqEanU4bgtUwywAUjvsSbrPXt00FTggOoTKYgGQ2uNneDZAl10InB0dQuWwAEjtsQTwzegQqpXbAtUYC4DULp8GNosOodrcCvw0OoTKYAGQ2mUE6arcuaODqDYHA49Hh1D3WQCk9lkV+EZ0CNXmSTwGWg2wAEjtdCAwMTqEavMz4MboEOo2C4DUTiOAo4Bx0UFUi2l4W6BqZgGQ2ms54HvRIVSbC4GzokOouywAUrvtB7w7OoRqcwDwSnQIdZMFQGq/XwALR4dQLe7AbYGqiQVAar8lgCOjQ6g2h+BtgaqBBUDqhp1J0wHqHrcFqhYWAKk7fgSsGR1CtTgctwWqYhYAqTvmBo4DxkYHUeWm4W2BqpgFQOqWNYBvR4dQLS4CzowOoe6wAEjd81ngPdEhVIsv4m2BqogFQOqeHuDXpIOC1C23Aj+JDqFusABI3bQQcCquB+gitwWqEhYAqbvWwaOCu+gp4OvRIdR+FgCp2z4D7B0dQpU7ArcFapgsAFL3/QxYLTqEKuW2QA2bBUDqvnmB3wHzRwdRpS4CzogOofbqiQ5QgYWAdwETgdWBFUh3pC9IN35/UlXOAN4HTI8OosqsTJoKGBMdRAMyAbg/OkQXbE76VPMSMMPHx2dAz6Goa75P/PeVz8CepebwZxiijZ+Q1wB+DGwVHURqoRnALsAp0UFUmQWB24BFo4OoX1mNALRpDcAI4N+Ba/HlLw1VD3A0XhrUJU8B/xUdQu3TlhGAeYCTgEnRQaSOuAvYCA+U6YqRpA9HFru8OQIwSPMC5+HLX6rS8sAfSDcIqv2mAZ+PDqF2yb0AjCIt9NssOojUQZsCR9GekUD17QLg9OgQao/cC8BBwPbRIaQO2x13BnSJtwVqwEZGB+jDRqTFSn46keq1BXAvcF10EA3bE8CywLrBOdS7HwDPRId4Va4v1x7gamD96CBSIV4BdiCdLqd2Wwn4B3l/wCuViwAH4D348peaNAb4PbBedBAN2+3AydEhlL9cC4CrWaXmzQ+cDawYHUTDZgFQv3KcAlgGuJs8s0kluJu0Q+DB6CAasvmBR/GOgNw4BdCP9+LLX4q0HHAOsEB0EA3ZM8Dk6BDKW44FYGJ0AEmsTdpTPk90EA3ZrdEBlLccC8Da0QEkAWl74Gl4WmBb3RcdQHnLrQCMJO1hlZSHrUmncTqX3D4PRAdQ3nIrAONIx/9Kysck4ERgdHQQDUpuP9+Vmdy+QZxvlPL0PuAYPFymTeaPDqC85VYAcssjaZbdSCXAUbp2cBeH+uQLV9Jg7EE6MdCFgflbIzqA8mYBkDRYOwKnAmOjg6hPm0QHUN4sAJKGYgfSOQHzRgdRr5YDlowOobxZACQN1dakEwMXjA6iN9kjOoDyZwGQNBybA5eRzjhXHkYA+0aHUP4sAJKGa3XgUmDV6CAC0rkNy0aHUP4sAJKqsAzp8plNo4MUbgzwnegQagcLgKSqLAT8kXSjp2J8CXhbdAi1gwVAUpXmIZ0T8KXoIAVaC/j36BBqDwuApKqNAA4DjsMDg5qyGHAGns2gQbAASKrLHqQpgfHRQTpuXtKZDEtHB1G7WAAk1Wlz4Epg3eggHbUgcB7w9uggah8LgKS6LU/aIeDe9Gq9BfgT7rzQEFkAJDVhbuDnwC9wXUAVlgb+DKwTHUTtZQGQ1KRPAJeTRgU0NBsAfwFWiQ6idrMASGraesB1wH7RQVpoZ+ASYPHoIGo/C4CkCOOAI4AT8DKhgegBvgz8jnTWgjRsFgBJkXYDrgcmRgfJ2DjgRNIRv/7MVmX8ZpIUbWnSavYjSC87zbIKcAWwS3QQdU9uBeCV6ACSQvSQ1gTcCGwfnCUXewN/Jd22KFUutwLwXHQASaGWAc4BfgMsEpwlygKkY5R/QzrlT6pFbgXgBeCJ6BCSwu0N3A58hXTFbSk2In3q3yM6iLovtwIAcFt0AElZWAj4NvA3YOvgLHUbC3yXdEbCCsFZVIgcC8Dk6ACSsrI6cD7wB2CN4Cx12Jy0E+KLwMjgLCpIjgXgwugAkrK0E+lF+Vtg5eAsVVgI+ClwMbBSbBSVqCc6QC9GAw8Ai0YHkZStqcCxwLdIawXapAf4MHAY6UIflWMCcH90iFflOAIwBTg6OoSkrI0C9gFuAU4DtowMMwgbki7xORpf/gqW4wgApHOu78JbwyQN3N+jGSh/AAAHwklEQVSAH5OOy30+OMvsliWNVuxOvj93VT9HAAbgQdLwmCQN1HqkT9aPAieRdg5Ev2yXBn4E/IO0tS86j/SanL8Z5ybth10tOoik1rqLtHvgTOBS0tqBuo0AtgI+QrrroKRzDNS3rEYAci4AkLb8/AVPw5I0fE8B55JW3V8B3ARMq+i/PRfpEJ8dgA+RftBLs7MADNIOpEU+o6ODSOqUZ4GrSFsL7wDunPk8ALzUx//fosCKM59VgE1mPmPrDKtOsAAMwU7A8fgXTFIzppAKwlMz//dY0rTkAuS7dkr5swAM0SakO7EdWpMktVFWBaBNTfYKYF3gGGBGcBZJklqtTQUA4HHSCVqbkq4MlSRJQ9CmKYDerALsBUwC1qZ9hUaSVI6spgDaXgBeb0HgbaRLQuab+URblXRcqSRJFoCCTCIdQCJJUlYFwCFzSZIKZAGQJKlAFgBJkgpkAZAkqUAWAEmSCmQBkCSpQBYASZIKZAGQJKlAFgBJkgpkAZAkqUAWgHpNjQ4gScrGK9EBXs8CUK+s/rAlSaGyeidYAOqV1R+2JCnUy9EBXs8CUK+XogNIkrIwg8w+FFoA6vVkdABJUhaeBqZFh3g9C0C9HosOIEnKwuPRAWZnAajXM2Q25CNJCpHdB0ILQP2y+0OXJDUuu3eBBaB+90YHkCSFuyc6wOwsAPW7JzqAJCncPdEBZmcBqN890QEkSeHujg4wOwtA/W6PDiBJCndndIDZWQDqd2N0AElSqKnAP6JDzM4CUL+byOzwB0lSo24hs2OAwQLQhBdxGkCSSpblSLAFoBlXRweQJIW5KjpAbywAzbg8OoAkKUyW7wALQDOy/MOXJNXueeC66BC9sQA042a8GVCSSnQlMCU6RG8sAM2YDlwQHUKS1LjzogPMiQWgOedEB5AkNS7bn/090QEKshjwL/yaS1Ip7geWBmZEB+mNIwDNeQi4JjqEJKkxZ5Lpyx8sAE07KTqAJKkxJ0QH6IvD0c2aANyLX3dJ6rqHgKXI+Ch4RwCadR9wRXQISVLtTibjlz9YACIcFR1AklS77H/WOxTdvPmAB4D5o4NIkmpxDfD26BD9cQSgec+R+cIQSdKwHBkdYCAcAYixFulsaL/+ktQtT5H2/j8bHaQ/jgDEuAE4PzqEJKlyh9OClz/4CTTStmR8RrQkadCmAMuTTgDMniMAcc4n0ysiJUlDcgwtefkDjIwOULiHgN2jQ0iShm0KsBstuvrdEYBYp5HuipYktdsvgbuiQwyGawDibQecGx1CkjRkLwEr0aLhf3AEIAfnkfF90ZKkfn2Xlr38wRGAXKxK2ho4OjqIJGlQHgBWAZ6PDjJYLgLMw2PAwsDG0UEkSYPyGeCv0SGGwhGAfMwP/J10ZbAkKX8XA+8EZgTnGBLXAOTjGeBT0SEkSQPyIrAvLX35g1MAubkdeBuwRnQQSVKf/gM4IzrEcDgFkJ/xpAWBi0cHkST16nJgIjAtOshwOAWQn8eAj9DiYSVJ6rCngb1o+csfnALI1V3AAsAm0UEkSW/wceDS6BBVcAogX6OBC4HNo4NIkoB01e+no0NUxQKQt8VI+0uXiA4iSYW7kjTv/3J0kKq4BiBvDwF7kG6ZkiTFeBj4IB16+YNrANrgXuAO4P04YiNJTXsReDdwc3SQqlkA2uHvpD+ridFBJKkg00mjsOdHB6mDBaA9LgaWBdaJjSFJxTgAODo6RF0sAO1yBunWKU8KlKR6/Sfpmt/Ock65fUYDpwI7RgeRpI76IXBgdIi6uQugfaYAuwBnRQeRpA76LvD56BBNcAqgnaYCJwOrAqsHZ5GkrvgO8JXoEE2xALTXdNJUwARg3eAsktRm00mf+r8RHaRJFoB2mwGcBjwFbIdrOiRpsF4GPgwcGR2kaRaAbriSdIHQJPwzlaSBehTYHjg3OkgEPzF2y/rAKcAy0UEkKXPXAh8A7o4OEsVdAN3yV2AD0i2CkqTeHQNsSsEvf3C4uIteAI4DRgHvwJInSa96Dvgk8HXSbqqiOQXQbZsAxwLLRweRpGBXAx8Cbo8Okgs/HXbbFaR1AUeTdgxIUmleJn3i3xRf/m/gCEA5tgB+TrpLQJJKMBnYlw5e5VsF1wCU417gVzP/fUPSGgFJ6qJHSDf5fW7mv6sXFoCyTAEuAn4NLAqshaNAkrpjCvC/wPtJU6BOffbBH/5lewdwKPDO6CCSNAzTSLufDgHuCM7SGhYAAWwFHAxsHh1EkgZhOulitIOBfwRnaR0LgF5vPdK82R64RkBSvl4GTgK+BdwSnKW1LADqzfLAfsA+wFtjo0jSa24Ffkla0Px4cJbWswCoL6OB9wAfBbYFxsTGkVSgp0m3nv4SuBQX9lXGAqCBWgh4H7Arac3AXLFxJHXY08DZwInAecBLsXG6yQKgoZiXtHNgB2AbYMXYOJJabhpwA+llfw7pAJ/iz+qvmwVAVViMdMzmZqSjh9cEFgxNJClnD5Fe+FeSXvaTgWdCExXIAqC6LAOsThodWG7mMwF4C7AIMDYumqSaPQc8RnrR/5N07e49pLP4bwAeDUum11gAFGUeYGHSwsIRwAKxcSQN0QzgqZn//iLwBGmbniRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJkiRJUlH+D3Zx0IZHyql0AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg124);
export default __webpack_public_path__ + "static/media/svg124.ea782febed0a9df2da00f0a815c808f0.svg";
export { ForwardRef as ReactComponent };